import { useCallback } from 'react'
import { analytics } from '@/common/analytics/analytics'
import type { PayIdDetails } from '@/wallet/types'

interface UseAddFundsLogicProps {
    payIdDetails?: PayIdDetails
    onClose: () => void
}

interface UseAddFundsLogicResult {
    defaultTab: 'payid' | 'account'
    showPayIdTab: boolean
    onHavePaidClick: () => void
    onWillTransferLaterClick: () => void
    introText: string
}

export function useAddFundsLogic({ payIdDetails, onClose }: UseAddFundsLogicProps): UseAddFundsLogicResult {
    const defaultTab = payIdDetails?.payId ? 'payid' : 'account'
    const showPayIdTab = !!payIdDetails?.payId

    const onHavePaidClick = useCallback(() => {
        onClose()
        analytics.trackWithDefaults('HavePaidButton Clicked')
    }, [onClose])

    const onWillTransferLaterClick = useCallback(() => {
        onClose()
        analytics.trackWithDefaults('WillTransferLaterButton Clicked')
    }, [onClose])

    const getIntroText = (): string => {
        if (!payIdDetails) {
            return 'To add funds to your wallet, transfer to our bank account details below.'
        }
        if (payIdDetails.payId) {
            return 'To add funds to your wallet, go to your online banking and transfer to our account using PayID or Bank account details provided below.'
        }
        return 'To add funds to your wallet, transfer to our bank account details below.'
    }

    return {
        defaultTab,
        showPayIdTab,
        onHavePaidClick,
        onWillTransferLaterClick,
        introText: getIntroText(),
    }
}
